import React from "react";

import {bindActionCreators} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import CloudFlyerAPI from "../../api/CloudFlyerAPI";
import {receiveError} from "../../api/http";
import moment from "moment";
import prettysize from "../../../src/utils";
import infoIcon from '../../assets/svg/info_icon.svg';


import {Modal, Checkbox, message, Table, Tooltip, Select, DatePicker} from "antd";

import "./index.scss";

const {Option} = Select;

const dateFormat = "YYYY/MM/DD";
const {RangePicker} = DatePicker;

class AdminTransferReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            transferHistory: [],
            userList: [],
            accountList: [],
            pageSize: 50,
            page: 1,
            total: 0,
            transferType: 0,
            accountId: "",
            userId: "",
            transferStatus: 0,
            useDate: false,
            startDate: "",
            endDate: "",
        };

        this.onChangeUser = this.onChangeUser.bind(this);
        this.onChangeAccount = this.onChangeAccount.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onPeriodChange = this.onPeriodChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            loading: true,
        });

        let filters = {
            sources: [],
        };

        if (this.state.transferType !== "") {
            filters['transferType'] = this.state.transferType;
        }

        if (this.state.accountId !== "") {
            filters['accountId'] = this.state.accountId;
        }

        if (this.state.transferStatus !== "") {
            filters['transferStatus'] = this.state.transferStatus;
        }
        if (this.state.userId !== "") {
            filters['userId'] = this.state.userId;
        }
        if (this.state.useDate) {
            if (this.state.startDate !== "") {
                filters['startDate'] = this.state.startDate;
            }
            if (this.state.endDate !== "") {
                filters['endDate'] = this.state.endDate;
            }
        }
        CloudFlyerAPI.user_account
            .getTransferHistory(filters, this.state.pageSize, this.state.page)
            .then(({data}) => {
                this.setState({
                    transferHistory: data.data,
                    loading: false,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                    historyLoading: false,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });

        CloudFlyerAPI.user_account
            .fetchAllUsers(0, 0, this.state.searchUser)
            .then(({data}) => {
                var res = data.data;
                console.log(data)
                var arr = {
                    username: "All",
                    id:""
                }
                res.unshift(arr)
                this.setState({
                    loading: false,
                    userList: res,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });

        CloudFlyerAPI.user_account
            .fetchAllAccounts(0, 0, this.state.accountName)
            .then(({data}) => {
                console.log(data, "accountList")
                var res= data.data
                var arr = {
                    name: "All",
                    id:""
                }
                res.unshift(arr)
                this.setState({
                    loading: false,
                    accountList: res,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }

    onPeriodChange = (value) => {

        let startDate = value[0];
        let endDate = value[1];

        this.setState({
            startDate: startDate,
            endDate: endDate,
        });

        if (this.state.useDate) {
            this.setState({
                loading: true,
            });

            let filters = {
                sources: [],
            };

            if (this.state.transferType !== "") {
                filters['transferType'] = this.state.transferType;
            }

            if (this.state.accountId !== "") {
                filters['accountId'] = this.state.accountId;
            }

            if (this.state.transferStatus !== "") {
                filters['transferStatus'] = this.state.transferStatus;
            }
            if (this.state.userId !== "") {
                filters['userId'] = this.state.userId;
            }
            if (this.state.useDate) {
                if (this.state.startDate !== "") {
                    filters['startDate'] = this.state.startDate;
                }
                if (this.state.endDate !== "") {
                    filters['endDate'] = this.state.endDate;
                }
            }
            CloudFlyerAPI.user_account
                .getTransferHistory(filters, this.state.pageSize, this.state.page)
                .then(({data}) => {
                    this.setState({
                        transferHistory: data.data,
                        loading: false,
                        pageSize: data?.options?.pageSize,
                        page: data?.options?.page,
                        total: data?.total,
                        historyLoading: false,
                    });
                })
                .catch((err) => {
                    const msg = receiveError(null, err).message;
                });
        }
    }

    onChange(e) {
        console.log(e.target.checked)
        this.setState({
            useDate: e.target.checked
        },() => {
            console.log(this.state.useDate);
                this.setState({
                    loading: true,
                });

                let filters = {
                    sources: [],
                };

                if (this.state.transferType !== "") {
                    filters['transferType'] = this.state.transferType;
                }

                if (this.state.accountId !== "") {
                    filters['accountId'] = this.state.accountId;
                }

                if (this.state.transferStatus !== "") {
                    filters['transferStatus'] = this.state.transferStatus;
                }
                if (this.state.userId !== "") {
                    filters['userId'] = this.state.userId;
                }
                if (this.state.useDate) {
                    if (this.state.startDate !== "") {
                        filters['startDate'] = this.state.startDate;
                    }
                    if (this.state.endDate !== "") {
                        filters['endDate'] = this.state.endDate;
                    }
                }
                CloudFlyerAPI.user_account
                    .getTransferHistory(filters, this.state.pageSize, this.state.page)
                    .then(({data}) => {
                        this.setState({
                            transferHistory: data.data,
                            loading: false,
                            pageSize: data?.options?.pageSize,
                            page: data?.options?.page,
                            total: data?.total,
                            historyLoading: false,
                        });
                    })
                    .catch((err) => {
                        const msg = receiveError(null, err).message;
                    });
        });
    }

    onPageChange = (page) => {
        this.setState({page: page, loading: true});


        let filters = {
            sources: [],
        };

        if (this.state.transferType !== "") {
            filters['transferType'] = this.state.transferType;
        }

        if (this.state.accountId !== "") {
            filters['accountId'] = this.state.accountId;
        }

        if (this.state.transferStatus !== "") {
            filters['transferStatus'] = this.state.transferStatus;
        }
        if (this.state.userId !== "") {
            filters['userId'] = this.state.userId;
        }
        if (this.state.useDate) {
            if (this.state.startDate !== "") {
                filters['startDate'] = this.state.startDate;
            }
            if (this.state.endDate !== "") {
                filters['endDate'] = this.state.endDate;
            }
        }
        CloudFlyerAPI.user_account
            .getTransferHistory(filters, this.state.pageSize, page)
            .then(({data}) => {
                this.setState({
                    transferHistory: data.data,
                    loading: false,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                    historyLoading: false,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });
    };

    on_transfer_type_change = (transferType) => {
        this.setState({
            transferType: transferType,
            loading: true,
        });

        let filters = {
            sources: [],
        };

        if (transferType !== "") {
            filters['transferType'] = transferType;
        }

        if (this.state.accountId !== "") {
            filters['accountId'] = this.state.accountId;
        }

        if (this.state.transferStatus !== "") {
            filters['transferStatus'] = this.state.transferStatus;
        }
        if (this.state.userId !== "") {
            filters['userId'] = this.state.userId;
        }
        if (this.state.useDate) {
            if (this.state.startDate !== "") {
                filters['startDate'] = this.state.startDate;
            }
            if (this.state.endDate !== "") {
                filters['endDate'] = this.state.endDate;
            }
        }
        CloudFlyerAPI.user_account
            .getTransferHistory(filters, this.state.pageSize, 1)
            .then(({data}) => {
                this.setState({
                    transferHistory: data.data,
                    loading: false,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                    historyLoading: false,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });


    };

    on_transfer_status_change = (transferStatus) => {
        this.setState({
            transferStatus: transferStatus,
            loading: true,
        });

        let filters = {
            sources: [],
        };

        if (this.state.transferType !== "") {
            filters['transferType'] = this.state.transferType;
        }

        if (this.state.accountId !== "") {
            filters['accountId'] = this.state.accountId;
        }

        if (transferStatus !== "") {
            filters['transferStatus'] = transferStatus;
        }
        if (this.state.userId !== "") {
            filters['userId'] = this.state.userId;
        }
        if (this.state.useDate) {
            if (this.state.startDate !== "") {
                filters['startDate'] = this.state.startDate;
            }
            if (this.state.endDate !== "") {
                filters['endDate'] = this.state.endDate;
            }
        }
        CloudFlyerAPI.user_account
            .getTransferHistory(filters, this.state.pageSize, 1)
            .then(({data}) => {
                this.setState({
                    transferHistory: data.data,
                    loading: false,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                    historyLoading: false,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });


    };

    onChangeUser(value) {
        console.log(`selected ${value}`);
        this.setState({
            userId: value,
            loading: true,
        });

        let filters = {
            sources: [],
        };

        if (this.state.transferType !== "") {
            filters['transferType'] = this.state.transferType;
        }

        if (this.state.accountId !== "") {
            filters['accountId'] = this.state.accountId;
        }

        if (this.state.transferStatus !== "") {
            filters['transferStatus'] = this.state.transferStatus;
        }
        if (value !== "") {
            filters['userId'] = value;
        }

        if (this.state.useDate) {
            if (this.state.startDate !== "") {
                filters['startDate'] = this.state.startDate;
            }
            if (this.state.endDate !== "") {
                filters['endDate'] = this.state.endDate;
            }
        }
        console.log(filters);
        console.log(value);

        CloudFlyerAPI.user_account
            .getTransferHistory(filters, this.state.pageSize, 1)
            .then(({data}) => {
                this.setState({
                    transferHistory: data.data,
                    loading: false,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                    historyLoading: false,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });

    }

    onChangeAccount(value) {
        console.log(`selected ${value}`);
        this.setState({
            accountId: value,
            loading: true,
        });

        let filters = {
            sources: [],
        };

        if (this.state.transferType !== "") {
            filters['transferType'] = this.state.transferType;
        }

        if (value !== "") {
            filters['accountId'] = value;
        }

        if (this.state.transferStatus !== "") {
            filters['transferStatus'] = this.state.transferStatus;
        }
        if (this.state.userId !== "") {
            filters['userId'] = this.state.userId;
        }

        if (this.state.useDate) {
            if (this.state.startDate !== "") {
                filters['startDate'] = this.state.startDate;
            }
            if (this.state.endDate !== "") {
                filters['endDate'] = this.state.endDate;
            }
        }
        CloudFlyerAPI.user_account
            .getTransferHistory(filters, this.state.pageSize, 1)
            .then(({data}) => {
                this.setState({
                    transferHistory: data.data,
                    loading: false,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                    historyLoading: false,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });

    }

    downloadTransferHistory = () => {

        var body = {
               "sources": []
        }
        if (this.state.useDate) {
            if (this.state.startDate !== "") {
                body['startDate'] = this.state.startDate;
            }
            if (this.state.endDate !== "") {
                body['endDate'] = this.state.endDate;
            }
        }

        if (this.state.transferType !== "") {
            body['transferType'] = this.state.transferType;
        }
        if (this.state.transferStatus !== "") {
            body['transferStatus'] = this.state.transferStatus;
        }
        if (this.state.accountId !== "") {
            body['accountId'] = this.state.accountId;
        }

        if (this.state.userId !== "") {
            body['userId'] = this.state.userId;
        }
        CloudFlyerAPI.user_account
            .downloadTransferHistory(body)
            .then(({data}) => {
                console.log(data);

                var startDate = new Date(this.state.startDate);
                var endDate = new Date(this.state.endDate);
                var encodedUri = encodeURI("data:text/csv;charset=utf-8," + data);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", "transfer-history-" + startDate.getFullYear() + "." + startDate.getMonth() + "." + startDate.getDate() + "-" + endDate.getFullYear() + "." + endDate.getMonth() + "." + endDate.getDate() + ".csv");
                document.body.appendChild(link); // Required for FF

                link.click();
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });

    };

    transferTooltip(data, t) {
        return (<div className="table-tooltip">{data} <Tooltip placement="left" title={(<div>Total Transfer Size: {prettysize(t.totalSize)}<br/>
            Total Objects: {t.total}<br/>
            Transferred Size: {prettysize(t.transferredSize)}<br/>
            Transferred: {t.transferred} <br/>
            Skipped: {t.skipped}<br/>
            Failed: {t.failed}<br/>
            Deleted: {t.deleted}
        </div>)}><img src={infoIcon} alt="info"/></Tooltip></div>);
    }

    render() {
        let transferStatuses = new Map();
        transferStatuses.set(0, "All");
        transferStatuses.set(2, "Ongoing");
        transferStatuses.set(4, "Completed");
        transferStatuses.set(128, "Paused");
        transferStatuses.set(8, "Cancelled");
        transferStatuses.set(16, "Failed");

        let directions = new Map();
        directions.set(1, "AWS to Wasabi");
        directions.set(2, "Wasabi to Wasabi");
        directions.set(4, "Azure to Wasabi");
        directions.set(8, "S3 Generic to Wasabi");
        directions.set(16, "Google to Wasabi");

        let transferTypes = new Map();
        transferTypes.set(0, "All");
        transferTypes.set(1, "Migration");
        transferTypes.set(2, "Replication");
        transferTypes.set(4, "Seed Data Replication");
        transferTypes.set(8, "Manual Transfer");

        const columns = [
            {
                title: "User",
                dataIndex: "username",
                key: "username",
                ellipsis: {
                    showTitle: false,
                },
                render: (username) => (
                    <Tooltip placement="topLeft" title={username}>
                        {username}
                    </Tooltip>
                ),
                width: 150,
            },
            {
                title: "Account",
                dataIndex: "accountName",
                key: "accountName",
                ellipsis: {
                    showTitle: false,
                },
                render: (accountName) => (
                    <Tooltip placement="topLeft" title={accountName}>
                        {accountName}
                    </Tooltip>
                ),
                width: 150,
            },
            {
                title: "Direction",
                dataIndex: "direction",
                key: "direction",
                width: 130,
            },
            {
                title: "Source Bucket",
                dataIndex: "source",
                key: "source",
                ellipsis: {
                    showTitle: false,
                },
                render: (source) => (
                    <Tooltip placement="topLeft" title={source}>
                        {source}
                    </Tooltip>
                ),
                width: 130,
            },
            {
                title: "Source Region",
                dataIndex: "sourceRegion",
                key: "sourceRegion",
                width: 120,
            },
            {
                title: "Destination Bucket",
                dataIndex: "destination",
                key: "destination",
                ellipsis: {
                    showTitle: false,
                },
                render: (destination) => (
                    <Tooltip placement="topLeft" title={destination}>
                        {destination}
                    </Tooltip>
                ),
                width: 130,
            },
            {
                title: "Destination Region",
                dataIndex: "destinationRegion",
                key: "destinationRegion",
                width: 120,
            },
            {
                title: "Date",
                dataIndex: "date",
                key: "date",
                width: 150,
            },
            {
                title: "Transfer Status",
                dataIndex: "transferStatus",
                key: "transferStatus",
                width: 120,
            },
            {
                title: "Transfer Type",
                dataIndex: "transferType",
                key: "transferType",
                width: 150,
            },
        ];

        let data = this.state?.transferHistory?.map((t, index) => {
            return {
                key: t.id,
                username: t.username,
                accountName: t.accountName,
                direction: directions.get(t.source),
                source: t.sourceBucket,
                sourceRegion: t.sourceRegion,
                destination: t.destinationBucket,
                destinationRegion: t.destinationRegion,
                date: moment
                    .parseZone(t.requestDate)
                    .local()
                    .format("MM/DD/YYYY HH:mm:ss"),
                transferStatus: transferStatuses.get(t.transferStatus),
                transferType: this.transferTooltip(transferTypes.get(t.transferType), t),
            };
        });

        return (
            <div className="usersListdashboard">
                <div className="date-wrapper">
                    <div className="start-date">
                        <h4>Filter Date: </h4>
                        <RangePicker
                            width={400}
                            onChange={(value) => this.onPeriodChange(value)}
                            defaultValue={[this.state.startDate, this.state.endDate]}
                            format={dateFormat}
                        />
                        <Checkbox onChange={this.onChange}>Use Date Filter</Checkbox>
                        {data.length > 0 &&
                            <div className="btn-wrapper">
                                <a href='#' className="ant-btn filter-usage-btn ant-btn-primary btn-style" onClick={this.downloadTransferHistory}>Download Report</a></div>
                        }

                    </div>
                </div>
                <div className="header">
                    <div className="left-wrapper">
                        <h2>Transfer Report</h2>
                    </div>


                    <div className="right-wrapper">
                        User:
                        <Select
                            showSearch
                            style={{width: 200}}
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            }
                            onChange={this.onChangeUser}
                        >
                            {
                                this.state.userList.map((data, index) => (
                                    <Option key={index} value={data.id}>{data.username}</Option>
                                ))
                            }
                        </Select>

                        &nbsp;&nbsp;&nbsp;&nbsp;Account:
                        <Select
                            showSearch
                            style={{width: 200}}
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            }
                            onChange={this.onChangeAccount}
                        >
                            {
                                this.state.accountList.map((data, index) => (
                                    <Option key={index} value={data.id}>{data.name}</Option>
                                ))
                            }
                        </Select>


                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Transfer Status:
                        <Select
                            onSelect={this.on_transfer_status_change}
                            defaultValue={this.state.transferStatus}
                            style={{width: 120}}
                        >
                            {[...transferStatuses].map((key) => (
                                <Option key={key[0]} value={key[0]}>
                                    {key[1]}
                                </Option>
                            ))}
                        </Select>
                        &nbsp;&nbsp;&nbsp;&nbsp; Transfer Type:
                        <Select
                            onSelect={this.on_transfer_type_change}
                            defaultValue={this.state.transferType}
                            style={{width: 120}}
                        >
                            {[...transferTypes].map((key) => (
                                <Option key={key[0]} value={key[0]}>
                                    {key[1]}
                                </Option>
                            ))}
                        </Select>

                    </div>
                </div>
                <div className="active-jobs-wrapper-sync">
                    <Table
                        loading={this.state.loading}
                        columns={columns}
                        dataSource={data}
                        pagination={{
                            onChange: this.onPageChange,
                            total: this.state.total,
                            current: this.state.page,
                            showTotal: (total, range) =>
                                `${range[0]}-${range[1]} of ${total} items`,
                            pageSize: this.state.pageSize,
                        }}
                        scroll={{y: 600}}
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(
    connect(
        ({auth}) => {
            let user = auth.user;
            return {
                ...user,
            };
        },
        (dispatch) => bindActionCreators({}, dispatch)
    )(AdminTransferReport)
);
